<template>
  <div>
    <b-row class="justify-content-center align-items-center">
      <b-pagination
        v-model="compCurrentPage"
        :total-rows="compRowCount"
        :per-page="compPerPage"
        first-number
        last-number
        aria-controls="table-tabela-proceda"
      />
    </b-row>
    <b-row class="justify-content-center align-items-center">
      {{ getPerPageSelectLabel }}
    </b-row>
    <b-row class="justify-content-center align-items-center mt-2">
      <div class="mt-2 mr-2">
        <label for="perPageSelect"> Registros por página: </label>
      </div>
      <div>
        <b-form-select
          v-model="compPerPage"
          id="perPageSelect"
          size="sm"
          :options="compPageOptions"
        />
      </div>
    </b-row>
  </div>
</template>

<script>
export default {
  props: {
    currentPage: Number,
    pageOptions: Array,
    perPage: Number,
    rowCount: Number,
  },
  computed: {
    getPaginationFrom() {
      return this.perPage * (this.currentPage - 1) + 1;
    },
    getPaginationTo() {
      let to = this.getPaginationFrom - 1 + this.perPage;
      if (to > this.rowCount) return this.rowCount;
      return to;
    },
    getPerPageSelectLabel() {
      return `Exibindo ${this.getPaginationFrom} até ${this.getPaginationTo} de um total de ${this.rowCount}`;
    },
    compPerPage: {
      get: function () {
        return this.perPage;
      },
      set: function (value) {
        this.$emit("update:perPage", parseInt(value));
      },
    },
    compCurrentPage: {
      get: function () {
        return this.currentPage;
      },
      set: function (value) {
        this.$emit("update:currentPage", parseInt(value));
      },
    },
    compRowCount: {
      get: function () {
        return this.rowCount;
      },
      set: function (value) {
        this.$emit("update:rowCount", parseInt(value));
      },
    },
    compPageOptions: {
      get: function () {
        return this.pageOptions;
      },
      set: function (value) {
        this.$emit("update:pageOptions", parseInt(value));
      },
    },
  },
};
</script>

<style scoped>
.label-top {
  padding-top: 1px !important;
}
</style>